<template>
  <div id="footer-bar" class="footer-bar-4" style="transform: translateX(0px)">
    <!-- <a href="#" class="active-nav"
        ><i class="fa fa-heart"></i><span>Pages</span></a
      >
      <a href="#"><i class="fa fa-star"></i><span>Features</span></a> -->
    <router-link :to="{ name: 'homeyouth' }"
      ><i class="fa fa-home"></i><span>{{ $t('home') }}</span></router-link
    >
    <!-- <a href="#"><i class="fa fa-image"></i><span>Media</span></a>
      <a href="#"><i class="fa fa-envelope"></i><span>Contact</span></a> -->
  </div>
</template>
<script>

export default {
  
};
</script>
